/**
 * Wave chat-identity-fix · 2026-05-26
 *
 * Utility puro pra decodificar payload de JWT no client SEM verificar
 * assinatura. Extraído de `auth-identity.ts` pra que `store/auth.store.ts`
 * possa importar isso sem criar ciclo de import (auth-identity importa
 * useAuth pra rodar audit; store precisa do decode pra rodar audit
 * inline em setUser/setSession).
 *
 * NÃO usar pra decisão de segurança — só pra ler claims públicos no
 * client (ex: confirmar que `me.id` casa com `JWT.sub`). Backend é quem
 * valida o token.
 */

export interface JwtPayloadShape {
  sub?: string;
  sid?: string;
  exp?: number;
  iat?: number;
}

function base64UrlDecode(input: string): string {
  const padLen = (4 - (input.length % 4)) % 4;
  const padded = input + '='.repeat(padLen);
  const b64 = padded.replace(/-/g, '+').replace(/_/g, '/');
  if (typeof atob !== 'function') return '';
  try {
    return atob(b64);
  } catch {
    return '';
  }
}

export function decodeJwtPayloadUnsafe(
  token: string | null | undefined,
): JwtPayloadShape | null {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const raw = base64UrlDecode(parts[1] ?? '');
  if (!raw) return null;
  try {
    const obj = JSON.parse(raw) as unknown;
    if (obj && typeof obj === 'object') {
      return obj as JwtPayloadShape;
    }
    return null;
  } catch {
    return null;
  }
}
